export class BogieShim {
  MajorBogie: BogieShimNameModel;
  Id: number;
  ShimCount: number;
  Comment: string;
  Images: BogieShimImage[] = [];   
  Side: number;
  InspectionId: number;
  InspectionDate?: string; 
  InspectionSMU?: number;
  photoLoading?: boolean = false;
  BogieNumber?: number;
}
export class BogieShimImage {
  ImageId: number;
  ImagePath: string; 
  ImageUrl?: string;
}
export class BogieShimNameModel {
    BogieName: string;    
    BogieNumber: number;
}
export class BogieShimRequestModel{
  Id: number;
  ShimCount: number;
  Comment: string;
  Images: BogieShimImage[] = [];  
  Side: number;
  InspectionId: number;
  BogieNumber?: number;
}
export interface BogieHistoryRequestModel {
  InspectionId: number;
  Side: number;
}
export interface InspectionBogieGroup {
  InspectionId: number;
  InspectionDate: string;
  InspectionSMU: number;
  BogieShim: BogieShim[];
}
export interface InspectionBogieGroupVM {
  Data: InspectionBogieGroup[];
  Status: number;
  Message: string;
}
export interface BogieImageModel {
  ImagePath: string;
  ImageUrl: string;
  IsInterp: boolean;
  ImageStatus: boolean;
  Id:number
}

export class BogieImageVM {
  ImageId: number;
  Image: string;
}
export class BogieCommentVM {
  BogieId: number;
  Comment: string;
}

export class BogieCountVM {
  BogieId: number;
  Count: number;
}

export class AddImageVM {
  BogieId: number;
  BogieNumber: number;
  Image: string;
}
export interface AddUpdateWorkOrder {
  InspectionId: number;
  WorkOrder: string;
}